import { render, staticRenderFns } from "./EditStusInfo.vue?vue&type=template&id=5a600587&"
import script from "./EditStusInfo.vue?vue&type=script&lang=js&"
export * from "./EditStusInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditStusInfo.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports